import defaultLogo from "../assets/images/cicoplogo.png";

const CARD = {
  width: 341,
  height: 580,
};

const WRAP = {
  gap: 28,
  width: `${CARD.width * 2 + 28}px`,
  height: `${CARD.height}px`,
};

const frontField = (top, left, extra = {}) => ({
  position: "absolute",
  top,
  left,
  zIndex: 2,
  ...extra,
});

const backField = (top, left, extra = {}) => ({
  position: "absolute",
  top,
  left,
  zIndex: 2,
  ...extra,
});

function CardBackground({ src, alt, showTemplate }) {
  if (!showTemplate) return null;

  return (
    <img
      src={src}
      alt={alt}
      className="certificate-bg-preview"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        pointerEvents: "none",
        zIndex: 1,
      }}
    />
  );
}

function FrontSide({ student, showTemplate }) {
  const college = student?.college || {};
  const studentPhoto = student?.studentPhoto?.url;
  const fullName = student?.fullName || "Student Name";
  const courseName = student?.course?.shortName || student?.course?.courseName || student?.courseAdmitted || "-";
  const mobile = student?.mobile || "-";
  const collegeName = college.name || "CENTRAL INDIA COLLEGE OF PHARMACY";
  const sansthaName = college.sansthaName || "MSMGBS, NAGPUR";
  const logoUrl = college.logo?.url || defaultLogo;

  const initials = fullName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "ST";

  return (
    <div
      style={{
        width: CARD.width,
        height: CARD.height,
        position: "relative",
        overflow: "hidden",
        borderRadius: 18,
        background: showTemplate ? "#fff" : "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
        border: "1.5px solid rgba(14, 116, 144, 0.25)",
        boxShadow: "0 16px 36px rgba(15, 23, 42, 0.16)",
      }}
    >
      <CardBackground
        src="/id-front.jpg"
        alt="ID card front"
        showTemplate={showTemplate}
      />

      {/* College Logo Top Corner */}
      {!showTemplate && logoUrl && (
        <div style={frontField(18, 20)}>
          <img src={logoUrl} alt={collegeName} style={{ width: 38, height: 38, objectFit: "contain" }} />
        </div>
      )}

      <div style={frontField(18, logoUrl && !showTemplate ? 66 : 28, {
        color: "#0f3d63",
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: "0.06em",
        maxWidth: 250,
        textTransform: "uppercase",
        lineHeight: 1.15
      })}>
        {sansthaName}
      </div>

      <div style={frontField(logoUrl && !showTemplate ? 38 : 34, logoUrl && !showTemplate ? 66 : 28, {
        color: "#155e75",
        fontSize: 15,
        fontWeight: 900,
        lineHeight: 1.1,
        maxWidth: 255,
        textTransform: "uppercase"
      })}>
        {collegeName}
      </div>

      <div
        style={frontField(120, 80, {
          width: 180,
          height: 180,
          borderRadius: "50%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: showTemplate ? "transparent" : "#8bc34a",
          border: "3px solid #0891b2",
          color: "#fff",
          fontSize: 44,
          fontWeight: 800,
        })}
      >
        {studentPhoto ? (
          <img
            src={studentPhoto}
            alt={fullName}
            style={{ width: "180px", height: "180px", objectFit: "cover" }}
          />
        ) : (
          initials
        )}
      </div>

      <div style={frontField(320, 20, { width: 301, textAlign: "center", color: "#0f172a" })}>
        <div style={{ fontSize: 19, fontWeight: 800, lineHeight: 1.15 }}>
          {fullName}
        </div>
        <div style={{ marginTop: 6, fontSize: 14, fontWeight: 700, color: "#075985" }}>
          Ph: {mobile}
        </div>
        <div style={{ marginTop: 6, fontSize: 14, fontWeight: 800, color: "#166534", textTransform: "uppercase" }}>
          {courseName} {student?.courseYear ? `· ${student.courseYear}` : ""}
        </div>
      </div>

      <div style={frontField(480, 20, { width: 301, textAlign: "center", color: "#334155", fontSize: 11, fontWeight: 700, lineHeight: 1.35 })}>
        <div>{college.address ? `${college.address}, ${college.city || "Nagpur"} - ${college.pincode || "441111"}` : "Kh. No. 25/1B, Mauza Lonara, Nagpur-441 111"}</div>
        <div style={{ marginTop: 4 }}>
          {college.contactEmail && `Email: ${college.contactEmail} `}
          {college.contactPhone && `· Ph: ${college.contactPhone}`}
        </div>
      </div>
    </div>
  );
}

function BackRow({ label, value, top }) {
  return (
    <>
      <div
        style={backField(top, 28, {
          width: 110,
          color: "#0f3d63",
          fontSize: 13,
          fontWeight: 800,
        })}
      >
        {label}
      </div>
      <div
        style={backField(top, 146, {
          width: 165,
          color: "#0f172a",
          fontSize: 12.5,
          fontWeight: 600,
          lineHeight: 1.35,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        })}
      >
        {value || "-"}
      </div>
    </>
  );
}

function BackSide({ student, showTemplate }) {
  const parentPhone =
    student?.fatherMobile ||
    student?.motherMobile ||
    student?.telephoneNo ||
    "-";

  const address = [
    student?.address,
    student?.city,
    student?.district,
    student?.state,
    student?.pincode,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div
      style={{
        width: CARD.width,
        height: CARD.height,
        position: "relative",
        overflow: "hidden",
        borderRadius: 18,
        background: showTemplate ? "#fff" : "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
        border: "1.5px solid rgba(14, 116, 144, 0.25)",
        boxShadow: "0 16px 36px rgba(15, 23, 42, 0.16)",
      }}
    >
      <CardBackground
        src="/id-back.jpg"
        alt="ID card back"
        showTemplate={showTemplate}
      />

      <BackRow label="Enrol. No.:" value={student?.enrollmentNo} top={120} />
      <BackRow label="Aadhar No.:" value={student?.aadharNo} top={155} />
      <BackRow label="Blood Group:" value={student?.bloodGroup} top={190} />
      <BackRow label="Date of Birth:" value={student?.dob} top={225} />
      <BackRow label="Parent Phone:" value={parentPhone} top={260} />
      <BackRow label="Address:" value={address} top={295} />
      <BackRow label="Emergency:" value={student?.emergencyContact || student?.mobile} top={375} />
    </div>
  );
}

export default function StudentIdentityCard({
  student,
  showTemplate = false,
}) {
  return (
    <div
      className="print-area"
      style={{
        width: WRAP.width,
        minHeight: WRAP.height,
      }}
    >
      <style>{`
        @media print {
          @page { size: A4 landscape; margin: 0.35in; }
        }
      `}</style>

      <div
        style={{
          display: "flex",
          gap: `${WRAP.gap}px`,
          alignItems: "flex-start",
          justifyContent: "center",
          flexWrap: "nowrap",
        }}
      >
        <FrontSide student={student} showTemplate={showTemplate} />
        <BackSide student={student} showTemplate={showTemplate} />
      </div>
    </div>
  );
}
